import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateAMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class ChangeExamStatusByMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/ChengeExamStatusByMaster");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class CalculateExamResult extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/CalculateExamResult");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterSalary extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/GetMasterSalary");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class ObserveTodayMasters extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/ObserveTodayMasters");
  }
}

class GetMasterDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/GetMaster");
  }

  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class SetInfoProfileMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/SetInfoProfileMaster");
  }

  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetInfoProfileMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/InfoProfileMaster");
  }

  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetInfoProfileMasterForAdmin extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Master/InfoProfileMasterForAdmin");
  }

  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateAMaster,
  ChangeExamStatusByMaster,
  CalculateExamResult,
  GetMasterSalary,
  ObserveTodayMasters,
  GetMasterDetails,
  SetInfoProfileMaster,
  GetInfoProfileMaster,
  GetInfoProfileMasterForAdmin,
};
